import {useTheme, View, withAuthenticator} from "@aws-amplify/ui-react";
import 'bootstrap/dist/css/bootstrap.min.css';
import {SystemNotification} from "./components/Alerts/SystemNotification";
import {Alert} from "react-bootstrap";
import {BioToolsUi} from "./components/BioToolsUi";
import {Amplify} from "aws-amplify";
import {awsconfig, currentEnv, shortenEnv} from "./Const";
import '@aws-amplify/ui-react/styles.css';
import enginebio_icon from "./output-onlinepngtools.png";
import { SYNERGY_FINDER_BUCKET_NAME } from "components/SynergyFinder/Const";
import { DATA_HUB_DATA_API_BUCKET_NAME } from "components/DataCatalog/DataHub/dataHubApiConsts";
import { PHARM_GEN_BUCKET_NAME } from "components/PharmGenAggregation/Const";
import { DATA_CONVERSION_BUCKET_NAME } from "components/DataConversion/Const";

export const restEndpoints = {
    "guide-primer-plasmid-api": {
        endpoint: `https://${shortenEnv}-guide-primer-plasmid-api.enginebio.io`,
    },
    "sangerqcpipelines": {
        endpoint: currentEnv === "develop" ? "https://en390iuwd7.execute-api.us-east-1.amazonaws.com/develop" : "https://k1c6xa1z8k.execute-api.us-east-1.amazonaws.com/production",
    },
    "common-api": {
        endpoint: `https://${shortenEnv}-common-api.enginebio.io`
    },
    "synergy-finder": {
        endpoint: `https://${shortenEnv}-synergy-finder.enginebio.io`
    },
    "gen-gen-data": {
        endpoint: `https://${shortenEnv}-gen-gen-data.enginebio.io`
    },
    "data-hub-data-api": {
        endpoint: `https://${shortenEnv}-data-hub-data-api.enginebio.io`,
    },
    "pharm-gen-aggregation": {
        endpoint: `https://${shortenEnv}-pharm-gen-aggregation.enginebio.io`,
    },
    "data-conversion": {
        endpoint: `https://${shortenEnv}-lab-to-cdd-conversion-api.enginebio.io`,
    }
}

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: awsconfig.aws_user_pools_id,
            userPoolClientId: awsconfig.aws_user_pools_web_client_id,
            identityPoolId: awsconfig.aws_cognito_identity_pool_id,
        }
    },
    API: {
        REST: restEndpoints
    },
    Storage: {
        S3: {
            bucket: awsconfig.aws_user_files_s3_bucket,
            region: awsconfig.aws_user_files_s3_bucket_region,
            // Register additional buckets used in the app so they can be referenced by name
            buckets: {
                [awsconfig.aws_user_files_s3_bucket]: { bucketName: awsconfig.aws_user_files_s3_bucket, region: awsconfig.aws_user_files_s3_bucket_region },
                [PHARM_GEN_BUCKET_NAME]: { bucketName: PHARM_GEN_BUCKET_NAME, region: awsconfig.aws_user_files_s3_bucket_region },
                [SYNERGY_FINDER_BUCKET_NAME]: { bucketName: SYNERGY_FINDER_BUCKET_NAME, region: awsconfig.aws_user_files_s3_bucket_region },
                [DATA_HUB_DATA_API_BUCKET_NAME]: { bucketName: DATA_HUB_DATA_API_BUCKET_NAME, region: awsconfig.aws_user_files_s3_bucket_region },
                [DATA_CONVERSION_BUCKET_NAME]: { bucketName: DATA_CONVERSION_BUCKET_NAME, region: awsconfig.aws_user_files_s3_bucket_region },
            },
        }
    }
});


// @ts-ignore
function App({signOut, user}: any) {
    return <BioToolsUi signOut={signOut} user={user}/>
}

export default withAuthenticator(App, {
    formFields: {
        signIn: {
            username: {
                labelHidden: true,
                placeholder: 'anybody@enginebio.com',
            },
        },
        signUp: {
            username: {
                labelHidden: true,
                placeholder: "Your enginebio.com internal email",
                isRequired: true,
            },
        }
    },
    components: {
        SignIn: {
            Header() {
                const {tokens} = useTheme()
                return <SystemNotification padding={tokens.space.small}  style={{marginBottom: "-2rem"}} />
            }
        },
        Header() {
            const {tokens} = useTheme();
            return (
                <View textAlign="center" padding={tokens.space.small}>
                    <img
                        alt="Engine logo"
                        src={enginebio_icon}
                    />
                </View>
            );
        },
        SetupTotp: {
            Header() {
                const {tokens} = useTheme();
                return <View padding={tokens.space.small}>
                    <Alert variant={"info"}>
                        <p>To protect Engine's data from malicious attackers, you must set-up MFA for your account.
                            Please install MFA app on your phone (we recommend Google Authenticator for iOS & Android),
                            or use existing MFA feature of your password manager, to scan QR code below.</p>
                    </Alert>
                </View>
            }
        }
    }
})
